/*
  Given a nodeMap and a progress-map object, this func iterates over the nodeMap
  using the progress-map data as guide.

  return the progress-path (as array of node-ids) and the id of the
  current node (the one to be completed), if any.

  nodemaps with loops, therefore without endings, will return null as current step.
 */
export function getCurrentProgressPath(nodeMap, progressMap) {
    var _a;
    // get first real step
    var nodeId = nodeMap['start'].children[0];
    var path = [];
    while (true) {
        // the completed path is a loop, there's no current step, abort!!
        if (path.indexOf(nodeId) > -1) {
            return [path, null];
        }
        var node = nodeMap[nodeId];
        var completed = (_a = progressMap[nodeId]) === null || _a === void 0 ? void 0 : _a.completed;
        // if step isn't completed, return its id
        if (completed == null) {
            break;
        }
        // it's a dead-end, return it's id
        if (node.type === 'ending' || node.children.length === 0) {
            break;
        }
        else if (node.type === 'decision') {
            var next = completed.nextNode;
            if (next != null && node.children.indexOf(next) > -1) {
                path.push(nodeId);
                nodeId = next;
            }
            else {
                // this decision step has an empty/invalid set_choice
                // so let's just assume this step is not completed
                break;
            }
        }
        else {
            // at this point we have completed content steps only
            // let's jump to the next step
            path.push(nodeId);
            nodeId = node.children[0];
        }
    }
    return [path, nodeId];
}
